import cssContent from '@assets/css/custom-menu-down.css';

export const customMenuDownStyleSheet = new CSSStyleSheet();
customMenuDownStyleSheet.replaceSync(cssContent);
